import Modal from '../../../../shared/Modal'
import { useState } from 'react'
import NumberInput from '../../../../shared/Inputs/NumberInput'
import Button from '../../../../shared/Buttons/Button'

interface IProps {
  initialIndex: number
  onChange: (index: number) => void
  onClose: () => void
}

const UpdateOrderingIndexModal = (props: IProps) => {
  const [index, setIndex] = useState(props.initialIndex)

  return (
    <Modal onClose={props.onClose} size="sm">
      <div className="flex-form">
        <h2 style={{ marginBottom: '1em', fontSize: 28 }}>Обновление индекса</h2>
        <NumberInput value={index} onChange={setIndex} name="index" label="Индекс" />
        <Button onClick={() => props.onChange(index)}>Сохранить</Button>
      </div>
    </Modal>
  )
}

export default UpdateOrderingIndexModal
